import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';  // Your existing auth logic
import { verifyToken } from '../api';      // Import the verifyToken function

const PublicRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const email = queryParams.get('email');

    if (token && email) {
      setIsLoading(true);

      // Call the verifyToken API function
      verifyToken(email, token)
        .then((result) => {
          setIsLoading(false);
          if (result && result.authToken) {
            // Successfully verified the token
            localStorage.setItem('authToken', result.authToken);
            localStorage.setItem('is_admin', result.is_admin);  // Save the auth token
            localStorage.setItem('loggedInUserEmail', result.email);  // Save the email
            
            if(result.is_admin)
              {
                navigate('/dashboard', { state: { message: 'Login Successfull' } });
              }
            else{
              navigate('/orders-lisiting', { state: { message: 'Login Successfull' } });

            }
          } 
          else {
            // Invalid token
            navigate('/login', { state: { message: 'Invalid login link' } });
          }
        })
        .catch(() => {
          setIsLoading(false);
          navigate('/login', { state: { message: 'Invalid login link' } });  // Redirect on failure
        });
    }
    

    //This check if there is no auth token and also this not admin then redirect to login screen
    if(!localStorage.getItem('authToken') && !localStorage.getItem('is_admin')){
      navigate('/login', { state: { message: 'Invalid login link' } });  // Redirect on failure
      }

    
    // This check is for analyst if the user is not in perform qa screen then redirect to orders-listing page
    if(localStorage.getItem('authToken') && localStorage.getItem('is_admin') == 'false'){

    // setIsLoading(false);
    if(window.location.pathname !== "/perform-qa"){
      navigate('/orders-lisiting', { state: { message: 'Login Successfull' } });
    }
    }
     
    
  }, [location.search, navigate]);

  return children;
};

export default PublicRoute;
